<template>
    <div class="box">
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" :colon="false">
            <a-form-model-item
                    ref="title"
                    label="标题"
                    prop="title"
                    :help="formErr.title"
                    :validateStatus='!formErr.title||formErr.title==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.title"
                        @change="(e) => { formErr.title=''}"
                        @blur="(e) => {  form.title = e.target.value.trim();}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="video_id"
                    label="视频ID"
                    prop="video_id"
                    :help="formErr.video_id"
                    :validateStatus='!formErr.video_id||formErr.video_id==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.video_id"
                        @change="(e) => { formErr.video_id=''}"
                        @blur="(e) => {  form.video_id = e.target.value.trim();}"
                />
            </a-form-model-item>

            <a-form-model-item
                    ref="thumb"
                    label="封面"
                    prop="thumb"
                    :extra="formErr.thumb"
            >
                <a-upload
                        :action="this.$store.state.urlChang"
                        :data="{type:1}"
                        :file-list="fileList"
                        :headers="headers"
                        @change="(file)=>{handleChange(file)}"
                        :before-upload="beforeUpload"
                        @preview="handlePreview"
                        list-type="picture-card"
                        name="file"
                >
                    <div v-if="fileList.length < 1">
                        <a-icon type="plus"/>
                        <div class="ant-upload-text">Upload</div>
                    </div>
                </a-upload>
                <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                    <img :src="previewImage" alt="example" style="width: 100%"/>
                </a-modal>
                <p>建议尺寸：上传一张490*368px不超过2M的jpeg、jpg、png格式的图片</p>
            </a-form-model-item>
            <a-form-model-item
                    ref="apply"
                    label="应用到"
                    prop="apply"
                    :extra="formErr.apply"
                    :validateStatus='!formErr.apply||formErr.apply==""?"":"error"'
            >
                <a-select v-model="form.apply">
                    <a-select-option :value="item.value" v-for="(item, idx) in apply" :key="idx">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" v-for="(item, idx) in this.status" :key="idx"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item  >
                <a-row>
                    <a-col :span="12">
                    </a-col>
                    <a-col :span="12">
                        <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                            确定
                        </a-button>
                        <a-button  @click="onClose">
                            返回
                        </a-button>
                    </a-col>
                </a-row>
            </a-form-model-item>
        </a-form-model >


    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../utils/utils"

    import API from "./api";
    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    export default {
        name: "EditForm",
        data() {
            // let validator2=(rule, value, callback,errval)=> {
            //     let formerrname=rule.field
            //     alert(this.fileList.length)
            //     if( errval!=""){
            //         callback(new Error(errval))
            //     } else if( this.fileList.length < 1){
            //         callback(new Error("请选择封面"))
            //     } else{   callback();}
            // }
            return {
                id: this.$route.query.id,
                apply:"",
                status:"",
                headers: {Authorization: window.sessionStorage.getItem("signature")},
                seleList:[],
                fileList:[],
                previewVisible: false,
                previewImage: "",
                form: {
                    title:"",
                    video_id:"",
                    thumb:"",
                    apply:"",
                    status:1,
                },
                formErr: {
                    title:"",
                    video_id:"",
                    thumb:"",
                    apply:"",
                    status:"",
                },
                rules: {
                    title: [{required: true, message: "请输入标题 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.title)}  , trigger: "blur"  },],
                    video_id: [{required: true, message: "请输入视频ID ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.video_id)}  , trigger: "blur"  },],
                    thumb:[{required: true, message: " ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.thumb)}  , trigger: "blur"  },  ],
                    apply: [{required: true, message: "请输入应用到 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.apply)}  , trigger: "blur"  },],

                },
                layout: {
                    labelCol: { span:3},
                    wrapperCol: { span: 12},
                },
            };

        },
        mounted(){
            if(this.id!=undefined){ this.editform( )}
            this.getFormData()
        },
        methods: {
            editform(){
                API.service.EDIT_DATA(this.id).then(res => {
                    let data=res.data.data.info
                    this.form = data
                    if (this.form.thumb == "") {
                        this.fileList = []
                    } else {
                        this.fileList = [
                            {uid: this.form.thumb,
                                name: this.form.thumb,
                                status: "done",
                                url: this.form.thumb ? this.form.thumb : ""
                            }
                        ]
                    }
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.contenta = data.content_text
                        }, 800)
                    })
                    this.form.id=this.id
                })
            },
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.apply=res.data.data.apply
                    this.status=res.data.data.status

                })
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange(info ) {
                let {fileList} = info;
                const status = info.file.status;
                let _that=this
                if (status !== 'uploading') {
                    this.fileList=[]
                }
                if (status === 'done') {
                    this.formErr.thumb=""
                    this.fileList= fileList
                } else if (status === 'error') {
                }
                if (status === 'uploading') {
                    this.fileList= fileList
                }
                if (status=== 'done') {
                    getBase64(info.file.originFileObj, imageUrl => {
                        _that.formErr.thumb=""
                        this.fileList= fileList
                    });
                }
                //重新设置state
                // this.setState( {fileList});
            },
            beforeUpload(file) {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isJpgOrPng) {
                    this.$message.error('只能上传jpeg，jpg，png类型图片!');
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('图片必须小于 2MB!');
                    return false
                }
                return new Promise(function (resolve,reject) {
                    resolve(file)
                })
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            onClose() {
                this.$router.push({path: '/WebsiteDetection/VideoSuggestions'})
            },
            onSubmit() {
                let _this = this;
                if (_this.fileList.length < 1) {
                    _this.formErr.thumb = "请上传封面图";

                }  else {
                    _this.formErr.thumb = "";
                    _this.form.thumb = _this.fileList[0].url
                }
                if (_this.fileList.length > 0 && _this.fileList[0].url) {
                    _this.form.thumb = this.fileList[0].url
                } else if (_this.fileList.length > 0 && _this.fileList[0].response) {
                    _this.form.thumb = _this.fileList[0].response.data.url
                } else {
                    _this.form.thumb = ""
                }
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                setTimeout(() => {
                                    this.onClose()
                                }, 1500)
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    }
                });
            },
        },
    }
</script>

<style scoped>
    .ant-input-number-input{width: 100%!important;}
    .ant-input-number{width: 100%!important;}
    .box >>> .ant-form-extra{top:calc(100% - 30px) !important;position: absolute}
    .box >>> .ant-form-item-control-wrapper{position: relative}
</style>
